import { MapLayer } from "react-leaflet";
import L from "leaflet";
import "leaflet-routing-machine";
import { withLeaflet } from "react-leaflet";
import ErrorBoundary from '../ErrorBoundary/ErrorBoundary'

class Routing extends MapLayer {
  createLeafletElement() {
    const { map } = this.props;
    let leafletElement = L.Routing.control({
      waypoints: [L.latLng(this.props.userLocationLat, this.props.userLocationLon),
                  L.latLng(this.props.selectedLinkLat, this.props.selectedLinkLon)]
    }).addTo(map.leafletElement);
    return leafletElement.getPlan();
  }
}
export default withLeaflet(Routing);


/**
 * waypoints: [L.latLng(this.props.userLocationLat, this.props.userLocationLon),
                  L.latLng(this.props.selectedLinkLat, this.props.selectedLinkLon)]
 */